import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: false,
    chatRoomId: null,
    groupCreationUsersList: [],
    groupName: null,
    chatCloseFunction: null,
    rowDetails: null,
    refreashNeeded: false,
    isAiMode: false,
    aiHistory: [],
};


const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    openChat: (state, action) => {
      return {
        ...state,
        open: true,
        ...action.payload,
      };
    },
    closeChat: (state) => ({ ...initialState, refreashNeeded: state.refreashNeeded, aiHistory: state.aiHistory }),
    setRefreashNeeded: (state, action) => {
      state.refreashNeeded = action.payload;
    },
    setAiHistory: (state, action) => {
        state.aiHistory = action.payload;
    }
  },
});
export const { openChat, closeChat, setRefreashNeeded, setAiHistory } = chatSlice.actions;

export default chatSlice.reducer;
